"use client";

export default function Error() {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-6">
      <h2 className="text-2xl font-bold">Có lỗi xảy ra</h2>
      <p className="text-lg">Không thể tải bài viết. Vui lòng thử lại sau.</p>
    </div>
  );
}
